import Popup from 'ol-ext/overlay/Popup';
import Select from 'ol/interaction/Select';
import {click} from 'ol/events/condition';
import TileLayer from 'ol/layer/Tile.js';
import TileWMS from 'ol/source/TileWMS';

export default (map, layers) => {
    const popup = new Popup ({	
        popupClass: "default", //"tooltips", "warning" "black" "default", "tips", "shadow",
        closeBox: true,
        onshow: function(){  },
        onclose: function(){  },
        positioning: 'top-auto',
        autoPan: true,
        autoPanAnimation: { duration: 250 }
    });

    map.addOverlay(popup);

        // Select  interaction
    var select = new Select({
        hitTolerance: 5,
        multi: false,
        //condition: click,
		layers: layers,
		style: null,
    });
    map.addInteraction(select);
    
    // On selected => show/hide popup	
	var me	
	select.on("select", function(e){
   // select.getFeatures().on(['add'], function(e) {
	   
		let attr = e.target.getFeatures().item(0);
		if(typeof(attr) != "undefined"){
			let layer_name = select.getLayer(attr).get("title");
			// create HTML content
			//layer title
			let html_title = $("<h3/>").text(layer_name);
			
			//table
			let table = $("<table />");
			let even = false;
			
			for(var i in attr.values_){
				if(i != "geometry"){
					let trclass = (even)?"even":"odd";
					let tr = $("<tr />").attr("class", trclass);
					tr.append($("<td />").html(i));
					tr.append($("<td />").html(attr.values_[i]));			
					table.append(tr);
				}
				even = !even;
			}
			
			/*
			const _location = '<b>Location: </b>' + feature.get("location");
			const _code = feature.get("vineyard_code") ? '<b>Vineyard code: </b>' + feature.get("vineyard_code") : "";
			const _vineyard = '<b>Vineyard: </b>' + feature.get("vineyard");
			const content = [_location, _code, _vineyard].join('<br>');
			*/
					
			popup.show(e.mapBrowserEvent.coordinate, html_title[0].outerHTML+table[0].outerHTML); 
		}
		
    })
    select.getFeatures().on(['remove'], function(e) {
		popup.hide(); 
    })
	
	// WMS get feature info version
	map.on('singleclick', function (evt) { 
		
		var pixel = map.getEventPixel(evt.originalEvent);
		let stop = false;
		  var hit = map.forEachLayerAtPixel(pixel, function (obj) {	// loop trough clicked layers
			if(obj instanceof TileLayer){	
					for(let i in layers.reverse()){
						if(layers[i] instanceof TileLayer && !stop){
							if(obj.values_.title == layers[i].values_.title){	// tile layer on map == tile layer on layer list
								// this layer is on top of popup raster layers		
								
								// proxy case
								// if WMS getFeatureInfo not working becouse of CORS, new proxy source is needed
								let proxy = {	"RKG_BLOK_GERK": "https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=2&"};								
								let wmsSource;
								
								if(proxy.hasOwnProperty(layers[i].values_.source.params_.layers)){	
									
									// create new tileWMS with proxy url
									let fake_source = new TileWMS({
										url:proxy[layers[i].values_.source.params_.layers],
										params: layers[i].values_.source.params_,
										projection: layers[i].values_.source.projection_.code_,
									  });
									 
									wmsSource = fake_source;
								}else{
									wmsSource = layers[i].values_.source;
								}

																
								var url = wmsSource.getFeatureInfoUrl(
									evt.coordinate,
									map.getView().getResolution(),
									'EPSG:3857',
									{'INFO_FORMAT': 'text/html',
										'QUERY_LAYERS': layers[i].values_.source.params_.layers}
								  );
								  if (url) {
									fetch(url)
									  .then(function (response) { return response.text(); })
									  .then(function (html) {
										  																				
										let flag = true;
										if(typeof(popup.values_.position) != "undefined"){
											flag = popup.values_.position != evt.coordinate;
										}
																				
										if(flag){
											popup.show(evt.coordinate, html);
										}
									  });
								  }
								  
								  stop = true;	//stop foreachlayeratpixel loop
							}
						}
					}
				}			
		  });
	});
}